const Blockly = require('blockly');
const blocklyWorkspace = require('../../src/blockDefinition/blocklyWorkspace');

/* istanbul ignore next */
module.exports = {
    getXmlText,
    getWorkspaceForXmlText,
    getWorkspace
};

function getWorkspace(componentGroup, hasChildren, includeSecurityModifiers) {
    let xmlText = getXmlText(componentGroup, hasChildren, includeSecurityModifiers);
    defineContainerBlock();
    return getWorkspaceForXmlText(xmlText);
}

function defineContainerBlock() {
    Blockly.Blocks['testblock'] = {
        init: function () {
            this.appendStatementInput('testInput').setCheck(null);
        }
    };
    Blockly.JavaScript['testblock'] = function (block) {
        return Blockly.JavaScript.statementToCode(block, 'testInput');
    };
}

function getWorkspaceForXmlText(xmlText, _namespaces) {
    let xml = Blockly.Xml.textToDom(xmlText);
    const namespaces = _namespaces || [
        { title: 'ns', prettyName: 'ns', relations: [{ title: 'rel', prettyName: 'rel' }] }
    ];
    const toolbox = blocklyWorkspace.configureWorkspace(null, namespaces);
    let workspace = new Blockly.Workspace(
        Blockly.Options({
            collapse: true,
            comments: false,
            disable: true,
            maxBlocks: Infinity,
            trashcan: true,
            horizontalLayout: false,
            toolboxPosition: 'start',
            css: true,
            media: 'https://blockly-demo.appspot.com/static/media/',
            rtl: false,
            scrollbars: true,
            sounds: true,
            oneBasedIndex: true,
            grid: { spacing: 20, length: 1, colour: '#888', snap: true },
            move: {
                scrollbars: {
                    horizontal: true,
                    vertical: true
                },
                drag: true,
                wheel: true
            },
            zoom: {
                controls: true,
                wheel: true,
                startScale: 1.0,
                maxScale: 3,
                minScale: 0.3,
                scaleSpeed: 1.2,
                pinch: true
            },
            toolbox
        })
    );
    Blockly.Xml.domToWorkspace(xml, workspace);
    return workspace;
}

function getXmlText(componentGroup, hasChildren, includeSecurityModifiers) {
    const children = hasChildren
        ? `
                <statement name="children">
                  <block type="${componentGroup}_testComponent2">
                  </block>
                </statement>`
        : '';

    let securityModifier = includeSecurityModifiers
        ? `
<value name="securityModifier">
    <block type="hiddenfor" id="%.aIjv@}#k[Dh|W6a~x4">
        <field name="hiddenfor">NEWUSER</field>
        <value name="securityModifier">
            <block type="hiddenfor" id="Ucyo,;[(u%OM-Yat,RIT">
                <field name="hiddenfor">user</field>
            </block>
        </value>
    </block>
</value>`
        : '';

    return `<xml>
        <block type="testblock" >
            <statement name="testInput">
                <block type="${componentGroup}_testComponent1" >
                    <field name="title">testTitle1</field>
                    ${securityModifier}
                    ${children}
                    <next>
                        <block type="${componentGroup}_testComponent2" >
                            <field name="title">testTitle2</field>
                        </block>
                    </next>
                </block>
            </statement>
        </block>
    </xml>`;
}
